import request from '@/plugin/axios'

export function page(data) {
    return request({
        url: '/api/case/czSettlementData/czSettlementDataList',
        method: 'post',
        data
    })
}

export function initData(data) {
    return request({
        url: '/api/case/czSettlementData/initData',
        method: 'get'
    })
}
